import * as z from "zod";

const GetSfomBacksyncStatusInputSchema_ = z.object({ teamId: z.string() });

export const GetSfomBacksyncStatusInputSchema: z.ZodType<GetSfomBacksyncStatusInput> =
  GetSfomBacksyncStatusInputSchema_;
export interface GetSfomBacksyncStatusInput extends z.infer<
  typeof GetSfomBacksyncStatusInputSchema_
> {}

const SfomBacksyncProgressSchema_ = z.object({
  cursor: z.string(),
  until: z.string(),
  pagesProcessed: z.number(),
  ordersSeen: z.number(),
  syncedCount: z.number(),
  failedCount: z.number(),
  progressPercent: z.string(),
});

const GetSfomBacksyncStatusOutputSchema_ = z.object({
  configured: z.boolean(),
  integrationId: z.string().nullable(),
  storeCode: z.string().nullable(),
  /** Live forward-sync cursor, untouched by the backsync. */
  ordersSyncAt: z.string().nullable(),
  syncInProgress: z.boolean(),
  progress: SfomBacksyncProgressSchema_.nullable(),
});

export const GetSfomBacksyncStatusOutputSchema: z.ZodType<GetSfomBacksyncStatusOutput> =
  GetSfomBacksyncStatusOutputSchema_;
export interface GetSfomBacksyncStatusOutput extends z.infer<
  typeof GetSfomBacksyncStatusOutputSchema_
> {}

export const getSfomBacksyncStatus = {
  name: "getSfomBacksyncStatus" as const,
  input: GetSfomBacksyncStatusInputSchema,
  output: GetSfomBacksyncStatusOutputSchema,
};
